import {Deserializable} from "./deserializable.model";

export class JobServiceTimeframe {

    // :; A service rule is assocuated with document types.

job_type_id: number;
job_service_timeframe_id: number;
job_service_timeframe_name: string;
job_service_timeframe_description: string;
is_active: string;
job_type_court_id: number;
job_type_location_id: number;
job_type_document_type_id: number;
job_service_rule_time_frame_text: number;
job_service_timeframe_count_type_id: number;
job_service_timeframe_date_type_id: number;
job_service_timeframe_time_type_id: number;
job_service_timeframe_time_when_id: number;
job_service_timeframe_number_count: number;
job_service_timeframe_additional_notes: string;




  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): JobServiceTimeframe {
    Object.assign(this, input);

    return this;
  }


}
